import { OwnUpSmallBody } from '@rategravity/own-up-component-library';
import React from 'react';
import { WidgetWrapper } from '../common/WidgetWrapper';
import { ABComparisonProvider } from './data/dataProvider';
import { Inputs } from './inputs';
import { CalculationSummary } from './summary';

const description = (
  <React.Fragment>
    <OwnUpSmallBody variant="body1">Fixed-rate loan comparison calculator</OwnUpSmallBody>
    <br />
    <OwnUpSmallBody variant="body1">
      The Fixed-rate loan comparison calculator is designed to help users evaluate and contrast the
      monthly payments and overall costs of different mortgage scenarios. By inputting values such
      as loan amount, loan term, interest rate, and any extra payments, users can easily compare two
      mortgage options side-by-side. This tool is perfect for those considering refinancing,
      purchasing a home, or exploring ways to accelerate their mortgage payoff. The calculator
      provides a detailed breakdown of monthly payments and the total cost over the life of the
      loan, enabling users to make informed decisions based on their financial goals. Whether
      you&apos;re a first-time homebuyer or an experienced property investor, this calculator
      simplifies complex mortgage comparisons into clear, actionable insights.{' '}
    </OwnUpSmallBody>
  </React.Fragment>
);

export const ABComparisonCalculator: React.FC = () => {
  return (
    <WidgetWrapper title="Fixed-rate loan comparison Calculator" description={description}>
      <ABComparisonProvider>
        <Inputs />
        <CalculationSummary />
      </ABComparisonProvider>
    </WidgetWrapper>
  );
};
